import React from "react";
import { BrowserRouter } from "react-router-dom";
import { baseName } from "app/config";

export function WithRouter<TProps extends {} = {}>(
  Child: React.ComponentType<TProps>
) {
  return (props: TProps) => (
    <BrowserRouter basename={baseName}>
      <Child {...props} />
    </BrowserRouter>
  );
}
